/** Must match `SINGLES_BUNDLE_MEMBER_SLUGS` in `supabase/functions/server/store-catalog-logic.ts`. */
export const SINGLES_BUNDLE_MEMBER_IDS: readonly string[] = [
  'dating-strategy',
  'profile-optimization',
  'red-flags-assessment',
  'first-date-guide',
  'compatibility-deep-dive',
  'breakup-prevention',
];
